// Per-device lists for the marketplace: products to compare and recently
// viewed. Conveniences only — losing them loses nothing (favorites, which
// should follow the account, live in the database: market_favorites).
// Every storage access is guarded: private windows and blocked storage throw.

export const COMPARE_MAX = 4;
const KEYS = { compare: 'maabar.market.compare', recent: 'maabar.market.recent' };
const RECENT_MAX = 24;
const listeners = new Set();

function read(key) {
  try {
    const v = JSON.parse(window.localStorage.getItem(key) || '[]');
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
  } catch { return []; }
}
function write(key, list) {
  try { window.localStorage.setItem(key, JSON.stringify(list)); } catch { /* storage unavailable: keep going */ }
  listeners.forEach((f) => f());
}
export const onMarketLocalChange = (f) => { listeners.add(f); return () => listeners.delete(f); };

export const compareIds = () => read(KEYS.compare);
/** Add or remove. Returns { ids, full } — full when the list is at the cap and the id was not in it. */
export function toggleCompare(id) {
  const ids = compareIds();
  if (ids.includes(id)) { const next = ids.filter((x) => x !== id); write(KEYS.compare, next); return { ids: next, full: false }; }
  if (ids.length >= COMPARE_MAX) return { ids, full: true };
  const next = [...ids, id]; write(KEYS.compare, next); return { ids: next, full: false };
}
export const clearCompare = () => write(KEYS.compare, []);

export const recentIds = () => read(KEYS.recent);
export function noteViewed(id) {
  if (!id) return;
  write(KEYS.recent, [id, ...recentIds().filter((x) => x !== id)].slice(0, RECENT_MAX));
}
